import React, { useEffect, useLayoutEffect, useState } from 'react';

import Collapse from 'react-bootstrap/Collapse';
import PropTypes from 'prop-types';
import useForm from '../../../utilities/useForm';

const FormLoader = ({
    cancelEdit,
    children,
    fetchData,
    getUrl,
    loadForm,
    postUrl,
    validator
}) => {
    const form = useForm(loadForm ? getUrl : undefined, postUrl);
    const [show, setShow] = useState(false);
    const [canShow, setCanShow] = useState(false);
    const [isClosed, setClosed] = useState(true);

    useEffect(() => {
        if (show) {
            setShow(false);
            setCanShow(false);
        }
        form.setUrl(loadForm ? getUrl : undefined);
        if (loadForm) {
            setTimeout(() => setCanShow(true), 300);
        }
    }, [loadForm]);

    useLayoutEffect(() => {
        if (form.isLoaded && loadForm && isClosed && canShow) {
            setShow(true);
        }
    }, [form.isLoaded, isClosed, canShow]);

    const submitForm = (successCallback) => {
        if (successCallback &&
            Object.prototype.toString.call(successCallback) === '[object Function]') {
            form.submitData((data) => {
                    successCallback(data);
                    //trigger data changed event for change log
                    window.dispatchEvent(new Event('updateChangeLog'));
                }, validator);
        } else {
            form.submitData((data) => {
                //call parent cleanup or edit view cancelEdit
                cancelEdit();
                //reload list data with new updates
                fetchData();
                //trigger data changed event for change log
                window.dispatchEvent(new Event('updateChangeLog'));
            }, validator);
        }
    };

    const child = form.item && React.cloneElement(children, {
        form: form,
        submitForm: submitForm
    });

    return (
        <React.Fragment>
            <Collapse
                in={show}
                unmountOnExit={true}
                onEntered={() => setClosed(false)}
                onExited={() => setClosed(true)}
            >
                <div className={isClosed && 'expanding'}>
                    {child}
                </div>
            </Collapse>
            <Collapse in={!show && loadForm}>
                <div className='text-center'>
                    Loading...
                </div>
            </Collapse>
        </React.Fragment>

    );
}

FormLoader.propTypes = {
    children: PropTypes.element.isRequired,
    getUrl: PropTypes.string,
    loadForm: PropTypes.bool.isRequired,
    postUrl: PropTypes.string,
    validator: PropTypes.func
};

export default FormLoader;